module.exports = __webpack_public_path__ + "img/model_img_35.4015b553.jpg";